import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TourismEventsComponent } from '../tourism-events.common';
import {
	CategoryEvent,
	DateKind,
	Driver,
	DriverEvent,
	EventClient,
	EventStatus,
	TourismEvent,
} from '../tourism-events.model';
import { Subject, takeUntil } from 'rxjs';
import { VirtualDrivers, VirtualDriversDeparture } from '@/common/enums/VirtualDrivers';
import { VehicleKind } from '@/vehicles/vehicle.model';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavbarModule } from '@/common/navbar/navbar.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TourismEventsOrganizationComponent } from '../tourism-events-organization/tourism-events-organization.component';
import { DatePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { RouterModule } from '@angular/router';
import {
	TourismEventsVehicleAddComponent,
	TourismVehicleOutput,
} from '@/tourism-events/tourism-events-full/tourism-events-vehicle-add/tourism-events-vehicle-add.component';
import { Permissions } from '@/common/enums/Permissions';

@Component({
	selector: 'app-tourism-events-technical-empty',
	templateUrl: './tourism-events-technical-empty.component.html',
	styleUrls: ['./tourism-events-technical-empty.component.css'],
	imports: [
		NavbarModule,
		NgSelectModule,
		FormsModule,
		ReactiveFormsModule,
		TourismEventsOrganizationComponent,
		NgClass,
		DatePipe,
		NgForOf,
		CKEditorModule,
		RouterModule,
		NgIf,
		TourismEventsVehicleAddComponent,
	],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourismEventsTechnicalEmptyComponent extends TourismEventsComponent {
	errors = {
		name: '',
		vehicles: [],
		owner: '',
		date_from: '',
		date_to: '',
		startDate: '',
		category: '',
		endDate: '',
	};

	readonly Permissions = Permissions;

	private readonly destroy$ = new Subject<void>();

	defaultValues(): void {
		this.event.status = EventStatus.PRELIMINARY;
		this.event.category = CategoryEvent.TECHNICAL_EMPTY;
		this._serviceEvent.getOrganization();
		this._serviceEvent.organization.pipe(takeUntil(this.destroy$)).subscribe((result) => {
			this.event.client = result;
			this.event.clientEvent = {
				client: result.id,
				event: null,
				isOrganization: EventClient.ORGANIZATION,
			};
		});
		this.event.drivers_departure.push();
	}

	checkAutoDate(driverEvent: DriverEvent, dateKind: string, event: boolean): void {
		switch (dateKind) {
			case DateKind.DATE_TO:
				driverEvent.dateToAuto = event;
				this.setAutoDate(driverEvent, dateKind, driverEvent.dateToAuto);
				break;
			case DateKind.DATE_FROM:
				driverEvent.dateFromAuto = event;
				this.setAutoDate(driverEvent, dateKind, driverEvent.dateFromAuto);
				break;
		}
	}

	setAutoDate(driverEvent: DriverEvent, date: string, dateAuto: boolean): void {
		const parms = this.event.drivers_departure.find((obj) => obj.driver === driverEvent.driver);
		if (!dateAuto) {
			return;
		}
		parms[date] = this.event[date];
		this.checkConfirmSalaryDrivers(driverEvent);
	}

	calculateDates(date: string): void {
		this.event.date_from = date;
		this.calculateDatePrepare();
		this.calculateDateDeadline();
		this.calculateDateAuto();
		this.calculateStartDate();
		this.calculateDateTo();
	}

	addVirtualDriver(event: TourismVehicleOutput[]): void {
		if (!event.length) {
			return;
		}
		if (this.event.drivers_departure.length || !this.event.vehicles.length) return;
		const vehicle = this.findVehicleById(this.event.vehicles[0]?.id);
		switch (vehicle.type.id) {
			case VehicleKind.COACH:
				this.event.drivers_departure = VirtualDriversDeparture.map((result) => {
					return {
						driver: result,
						date_from: this.event.date_from,
						date_to: this.event.date_to,
						dateFromAuto: true,
						dateToAuto: true,
					};
				});
			case VehicleKind.BUS:
				this.event.drivers_program.push({
					driver: VirtualDrivers.PROGRAM_ONE,
					date_from: this.event.date_from,
					date_to: this.event.date_to,
					dateFromAuto: true,
					dateToAuto: true,
				});
				break;
		}
	}

	changeDriverDeparture($event: string, driver: Driver, event: TourismEvent, driverIndex: number): void {
		const driverPayload = {
			...driver,
			driver: {
				...driver,
				driver: $event,
			},
		};
		event.drivers_departure[driverIndex].driver = $event;
		this.checkConfirmSalaryDrivers(driverPayload);
		this.checkEditedDriverDocument(event);
		this.changeDriver(driverPayload);
	}
}
